import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/scss/index.scss'
//引入vxe-table组件
import VXETable from '@/plugins/index'
import 'vxe-table/lib/style.css'
//引入指令
import directives from "./directives/index"
//引入nprogress样式
import 'nprogress/nprogress.css'
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'




const app = createApp(App)
app.use(Vue3DraggableResizable)
app.use(store)
app.use(router)
app.use(directives)
app.use(VXETable)
app.use(Viewer, {
    defaultOptions: {
        zIndex: 9999,
        toolbar: false,
        transition: false,
        title: false,
        navbar: false,
        // button:false,
        scalable: false,
        rotatable: false,
        tooltip: false,
        inline: false,
    }
})
app.mount('#app')
